let request;
let db;
let version = 1;

export const initDB = () => {
    return new Promise((resolve) => {
        request = indexedDB.open("myDB");

        request.onupgradeneeded = () => {
            db = request.result;

            if (!db.objectStoreNames.contains("people")) {
                console.log("Creating people store");
                const store = db.createObjectStore("people", { keyPath: "id" });
                store.createIndex("name", "name", { unique: false });
            }

            if (!db.objectStoreNames.contains("event")) {
                console.log("Creating event store");
                const store = db.createObjectStore("eventData", { keyPath: "id" });
            }
        };

        request.onsuccess = (e) => {
            db = request.result;
            // get current version and store it
            version = db.version;
            resolve(request.result);
        };

        request.onerror = (e) => {
            console.log("Erro ao abrir o banco de dados:", e);
            resolve(false);
        };
    });
};

export const addData = (storeName, data) => {
    return new Promise((resolve) => {
        request = indexedDB.open("myDB", version);

        request.onsuccess = () => {
            console.log("request.onsuccess - addData", data);
            db = request.result;
            const tx = db.transaction(storeName, "readwrite");
            const store = tx.objectStore(storeName);
            store.add(data);
            resolve(data);
        };

        request.onerror = () => {
            const error = request.error?.message;
            if (error) {
                console.log("request.onerror - erro:", error);
                resolve(error);
            } else {
                console.log("request.onerror - erro: Unknown error");
                resolve("Unknown error");
            }
        };
    });
};

export const updateData = (storeName, key, data) => {
    return new Promise((resolve) => {
        request = indexedDB.open("myDB", version);

        request.onsuccess = () => {
            console.log("request.onsuccess - updateData", key);
            db = request.result;
            const tx = db.transaction(storeName, "readwrite");
            const store = tx.objectStore(storeName);
            const res = store.get(key);
            res.onsuccess = () => {
                const newData = { ...res.result, ...data };
                store.put(newData);
                resolve(newData);
            };
            res.onerror = () => {
                resolve(null);
            };
        };
    });
};

export const getData = (storeName, key = null) => {
    return new Promise((resolve) => {
        request = indexedDB.open("myDB");

        request.onsuccess = () => {
            console.log("request.onsuccess - " + key ? "getData " + key : "getAll");
            db = request.result;
            const tx = db.transaction(storeName, "readonly");

            console.log(tx);

            const store = tx.objectStore(storeName);
            let res;
            if (key) res = store.get(key);
            else res = store.getAll();
            console.log("data found at db: ", res);
            res.onsuccess = () => {
                resolve(res.result);
            };
            res.onerror = () => {
                resolve(null);
            };
        };
    });
};

export const addMultipleData = async (storeName, data) => {
    try {
        const transaction = db.transaction(storeName, "readwrite");
        const store = transaction.objectStore(storeName);

        data.forEach((item) => {
            store.add(item);
        });

        // wait finish transaction
        await transaction.complete;
        return true;
    } catch (error) {
        console.error("Error adding data:", error);
        return false;
    }
};
